<template>
<div v-if="question" class="modal modal-large" id="question-preview">
  <div class="modal-content" role="document">
    <div class="modal-header">
      <a href="#UNSET" class="u-pull-right" aria-label="Close">
        <span class="icon">
          <i class="fa fa-wrapper fa-times"></i>
        </span>
      </a>
      <div class="modal-title">Question Preview</div>
    </div>
    <div class="divider u-no-margin"></div>
    <div class="modal-body">
      <p class="strong --fixed-min-width pre_line">{{ question.text }}</p>
      <ol v-if="isMultiChoice()" type="a">
        <li class="success">
          {{ question.answer }}
        </li>
        <li
          v-for="(val, idx) in getChoices()"
          :key="`question-${question.id}-${idx}`"
          >
          {{ val }}
        </li>
      </ol>
      <div v-else>
        <span v-if="!question.answer">[ No answer entered yet ]</span>
        <span v-else class="strong">Answer: <span class="success">{{ question.answer }}</span></span>
      </div>

      <div v-if="question.reference" style="margin: 1.5rem 0;">
        <strong>Syllabus:</strong> {{ question.syllabus }}
        </div>
        <div v-if="question.reference" style="margin: 1.5rem 0;">
          <strong>Reference:</strong> {{ question.reference }}
        </div>
        <table class="table">
          <thead>
            <tr>
              <th>
                Topic
              </th>
              <th>
                Marks
              </th>
              <th>
                Details
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span v-if="question.topic">
                  {{ question.topic.name }}
                </span>
              </td>
              <td>
                {{ question.marks }}
              </td>
              <td class="u-center">
                <question-status :question="question"></question-status>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<style>
.--fixed-min-width {
  min-width: 40rem;
}
</style>
<script>
import QuestionStatus from "@/components/questions/QuestionStatus";

export default {
  name: "question-create",
  props: ["question"],
  components: {
    QuestionStatus
  },
  methods: {
    getChoices: function() {
      var result = [];
      for (let idx in [1, 2, 3, 4, 5]) {
        if (
          this.question["choice_" + idx] &&
          this.question["choice_" + idx].length > 0
        ) {
          result.push(this.question["choice_" + idx]);
        }
      }
      return result;
    },
    isMultiChoice: function() {
      for (let idx in [1, 2, 3, 4, 5]) {
        // Choices aren't defined until something is typed, so skip if DNE
        if (!this.question["choice_" + idx]) {
          continue;
        } else if (this.question["choice_" + idx].length > 0) {
          return true;
        }
      }
      // We get this far and nothing was true, so it's NOT a multichoice
      return false;
    }
  }
};
</script>
